import React from 'react';
import PageTitle from '../PageTitle';
import $ from 'jquery';
import renderHTML from 'react-render-html';
import { doRequest } from '../../helper';

export default class FitIndiaAddSocial extends React.Component {
    constructor() {
        super();
        this.state = {
            video: null,
            link: null,
            type: 0
        }
        this.getSocial = this.getSocial.bind( this );
        this.saveSocial = this.saveSocial.bind( this );
    }
    componentDidMount() {

    }
    getSocial( event ) {
        var ref = this;
        var type = event.target.value;

        if ( this.url.value == "" ) {
            alert( 'Please input link first' );
            event.preventDefault();
            return false;
        }
        ref.setState( { "frame": null } );
        $( "#tweet" ).html( "" );

        if ( type == "facebook" ) {
            var link = this.url.value;
            var frame = <div className="fb-post"
                data-href={link}
                data-width="100%"
                data-show-text="true"></div>

            ref.setState( { "frame": frame, "type": type }, () => {
                window.FB.XFBML.parse();
            } );


        }
        if ( type == "twitter" ) {
            var link = this.url.value;
            if(link.indexOf("?") != -1){
                alert("Please input a clean link");
                return false;
            }
            link = link.split( "/" );
            link = link[link.length - 1];
            
            var frame = <div id="tweet" data-tweetid={link}></div>

            ref.setState( { "frame": frame, "type": type }, () => {

                var tweet = document.getElementById( "tweet" );
                var id = tweet.getAttribute( "data-tweetid" );
                window.twttr.widgets.createTweet(
                    id, tweet,
                    {
                        conversation: 'none',    // or all
                        cards: 'hidden',  // or visible 
                        linkColor: '#cc0000', // default is blue
                        theme: 'light'    // or dark
                    } ).then(( rds ) => {
                        console.log( rds );
                    } )

            } );
        }

        if ( type == "instagram" ) {

            var link = this.url.value;

            $.get( "https://api.instagram.com/oembed?url=" + link, function( response ) {
                if ( response.html ) {
                    ref.setState( { "frame": response.html, "type": type }, () => {
                        window.instgrm.Embeds.process()

                    } );
                }
            } );


        }
    }

    saveSocial() {
        //save the social media post here
        if ( $.trim( this.url.value ) == "" || $.trim( this.state.type ) == "" ) {
            alert( 'URL is required' );
            return false;
        }
        if(this.state.type == "twitter"){
            var link = this.url.value;
            link = link.split( "/" );
            link = link[link.length - 1];
            
        }
        var ref = this;
        var payload = {
            'action': 'save-post',
            'module': 'bday',
            'model': 'post',
            'data': {
                'social_post_type': this.state.type,
                'social_post_link': link ? link : this.url.value
            }
        };


        // $( ".loader" ).show();
        var request = doRequest( 'cms-operations', payload, true );

        request.addEventListener( "load", function() {

            $( ".loader" ).hide();
            var response = this.responseText;
            try {
                response = JSON.parse( response );
                if ( response._resultflag && response._resultflag == 1 ) {
                    alert( 'Social Post Saved' )
                    window.location.reload();
                    ref.url.value = '';
                }
            } catch ( ex ) {
                alert( 'Post can not be saved, please try again !' )
            }

        } );

    }

    render() {
        var video = this.state.video;

        return (
            <div><PageTitle title="NM BDAY 2018" bread="NM BDAY 2018 / Social Link" />
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-title">
                                    <h5>Add Social Media <small> Add New Post</small></h5>
                                    <div className="ibox-tools">
                                        <a className="collapse-link">
                                            <i className="fa fa-chevron-up"></i>
                                        </a>

                                    </div>
                                </div>
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-sm-6 b-r">

                                            <div className="form-group"><label>Social Link</label> <input ref={( url ) => { this.url = url }} type="text" placeholder="Twitter Id, Facebook/Instagram Link" className="form-control" /></div>
                                            <div className="form-group checkbox">
                                                <label>
                                                    <input type="radio" name="platform" ref={( facebook ) => { this.facebook = facebook }} onClick={this.getSocial} value="facebook" />
                                                    Facebook
                                                            </label>&nbsp;&nbsp; | &nbsp;&nbsp;
                                                <label>
                                                    <input type="radio" name="platform" ref={( twitter ) => { this.twitter = twitter }} onClick={this.getSocial} value="twitter" />
                                                    Twitter
                                                                </label>&nbsp;&nbsp; | &nbsp;&nbsp;
                                                <label>
                                                    <input type="radio" name="platform" ref={( instagram ) => { this.instagram = instagram }} onClick={this.getSocial} value="instagram" />
                                                    Instagram
                                                                </label>
                                            </div>
                                            <div>
                                                <button className="btn btn-sm btn-primary pull-right m-t-n-xs" type="submit" onClick={this.saveSocial}>
                                                    <strong>Save Post</strong></button>

                                            </div>

                                        </div>



                                        <div className="col-sm-6">
                                            <div className="text-center">

                                                {this.state.type == "instagram" ? renderHTML( this.state.frame ) : this.state.frame}
                                            </div>
                                        </div>



                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div > );
    }
}


// WEBPACK FOOTER //
// ./src/Components/NM_Birthday_Module_2018/AddSocial.jsx